import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {QueryClient, QueryClientProvider} from 'react-query'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import reducer, { initialState } from "./reducer";
import { DataLayer } from './DataLayer'
import { Provider } from 'react-redux'
import { store } from './app/redux/store'

setupAxios(axios)

const queryClient = new QueryClient()
const container = document.getElementById('root')

if (container) {
  createRoot(container).render(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <MetronicI18nProvider>
          <AuthProvider>
            <DataLayer initialState={initialState} reducer={reducer}>
              <AppRoutes />
            </DataLayer>
          </AuthProvider>
        </MetronicI18nProvider>
      </QueryClientProvider>
    </Provider>
  )
}
